import DirectDebitSepaMandate from './direct-debit-sepa-mandate';

export default DirectDebitSepaMandate;
